import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Title from '../../components/Title';
import { HostProvider } from '../../utils/HostProvider';
import BotonVolverFlotante from '../../components/BotonVolverFlotante';

const TitleBar: FC = () => {
  const { t } = useTranslation();
  const isCaprabo = HostProvider.isCaprabo();

  return (
    <section
      className={`${
        !isCaprabo ? 'o-section--medium' : ''
      } o-section--no-padding-top  section--background`}
    >
      <div className="container">
        <BotonVolverFlotante />
        <div className="cabecera-seccion">
          <Title titleName={t('datos.header')} page="mis-datos" />
        </div>
      </div>
    </section>
  );
};

export default TitleBar;
